/**
 * Surface a failed property list-item deletion to the operator.
 *
 * #638 normalized collection-item properties into `my.collection_item_property`
 * and added a backend guard: a list item still referenced by a collection item
 * can no longer be deleted — the handler throws
 * `badUserInputException("List Item is used in collection item properties")`.
 * The operator must REPLACE the item (reassign its references) first.
 *
 * The delete mutations had only `onCompleted`, so this rejection was swallowed:
 * the row never refreshed and no message appeared, so the trash button looked
 * dead ("defunct"). Show an actionable error toast instead.
 */
export default function notifyDeleteItemError(error, enqueueSnackbar) {
  if (!enqueueSnackbar) return;

  const raw = error?.message || '';
  const isUsed = /used in collection item properties/i.test(raw);

  const message = isUsed
    ? 'This item is still used by one or more collection items. Use “Replace item” to reassign them to another item, then delete it.'
    : // strip the dev `[handlerName]` prefix backend errors carry
      raw.replace(/^\[[^\]]*\]\s*/, '') || 'Could not delete this item.';

  enqueueSnackbar(message, { variant: 'error', persist: true });
}
